/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {FileCompletionStatus} from './diplomat/enums/FileCompletionStatus';
import {FileStatus} from './diplomat/enums/FileStatus';

export const FileHistoryNames = {
   sequence: 'sequence',
   source: 'source',
   destination: 'destination',
   startTime: 'startTime',
   endTime: 'endTime',
   status: 'status',
   completionStatus: 'completionStatus',
   size: 'size',
   numRetries: 'numRetries',
} as const;

export const FileHistory = yup.object({
   sequence: yup.string(),
   source: yup.string(),
   destination: yup.string(),
   startTime: yup.date(),
   endTime: yup.date(),
   status: yup.object({
      id: yup.string().oneOf(FileStatus.keys),
      subStatus: yup.string(), //.oneOf
   }),
   completionStatus: yup.string().oneOf(FileCompletionStatus.keys),
   size: yup.number().integer(),
   numRetries: yup.number().integer(),
});
export type IFileHistory = yup.InferType<typeof FileHistory>;
